<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.value" :value="item.value">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item v-for="item in items" :key="item.value">
        <div class="px-2">
          <component v-if="tab === item.value" :is="item.component"></component>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  ReportMealsTabMeals,
  ReportMealsTabPackages,
  ReportMealsTabEmployees,
  ReportCreditTabUsers,
} from "@/components/report/more-restaurants";

export default {
  props: {
    activeTab: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    tab: null,
  }),
  computed: {
    items() {
      return [
        {
          tab: this.$t("meals"),
          icon: "mdi-bowl-mix",
          component: ReportMealsTabMeals,
          value: 0,
        },
        {
          tab: this.$t("pak"),
          icon: "mdi-shopping-outline",
          component: ReportMealsTabPackages,
          value: 1,
        },
        {
          tab: this.$t("employees"),
          icon: "mdi-account",
          component: ReportMealsTabEmployees,
          value: 2,
        },
        {
          tab: this.$t("credit_users"),
          icon: "mdi-account",
          component: ReportCreditTabUsers,
          value: 3,
        },
        {
          tab: this.$t("taken_meals"),
          icon: "mdi-food-takeout-box",
          component: ReportMealsTabPackages,
          value: 4,
        },
      ];
    },
  },
  watch: {
    activeTab(newVal) {
      this.tab = newVal;
    },
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
